module.exports = __webpack_public_path__ + "img/track-icon.bf1201e4.png";